import { t } from 'i18next';
import upperFirst from 'lodash/upperFirst';

export const translateOptions = (values: string[], keyPrefix: string) => {
  return values.map((value) => ({
    label: t([`${keyPrefix}.${value}`, upperFirst(value)]),
    value,
  }));
};
